import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { gatewayBaseUrl, gatewayApiVersion } = CONFIG_VARS;

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: createBaseQuery(gatewayBaseUrl["1"], true), // Enable auth for token verification
  endpoints: (builder) => ({
    superAdminLogin: builder.mutation({
      query: (data) => ({
        url: `${gatewayApiVersion}/user/agents/login`,
        method: "POST",
        body: data.body,
      }),
    }),
    verifyToken: builder.mutation({
      query: () => ({
        url: `${gatewayApiVersion}/auth/verify-bearer`,
        method: "POST",
      }),
    }),
  }),
});

export const { useSuperAdminLoginMutation, useVerifyTokenMutation } = authApi;
